import { HeaderBar as e } from "./base/HeaderBar.js";
import { HeaderLink as t, HeaderNavLink as n } from "./base/HeaderLink.js";
import { HeaderRoot as r } from "./base/HeaderRoot.js";
import { DesktopNav as i } from "./desktop/DesktopNav.js";
import { MobileNav as a } from "./mobile/MobileNav.js";
//#region src/components/Header/Header.ts
var o = {
	Root: r,
	Bar: e,
	Link: t,
	NavLink: n,
	DesktopNav: i,
	MobileNav: a
};
//#endregion
export { o as Header };
